export default __webpack_public_path__ + "static/media/Gallery-4.09db787a.jpg";